import { useQuery } from '@tanstack/react-query';
import { getExternalConnectionCalendars } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const queryKey = 'external-connection-calendars';

export const useExternalConnectionCalendarsQuery = (externalConnectionId: ID) =>
  useQuery({
    queryKey: [queryKey, externalConnectionId],
    queryFn: () => getExternalConnectionCalendars(externalConnectionId),
    staleTime: 5 * 60 * 1000,
  });
